"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyResponse = void 0;
const ResponseBase_1 = require("../ResponseBase");
class EmptyResponse extends ResponseBase_1.ResponseBase {
}
exports.EmptyResponse = EmptyResponse;
